import React from 'react';
import cn from 'classnames';
import { string, node } from 'prop-types';
import CustomTableRow from './CustomTableRow';
import CustomTableCell from './CustomTableCell';

const propTypes = {
  children: node.isRequired,
  className: string,
};

const CustomTablePlaceholder = ({ children, className }) => {
  return (
    <CustomTableRow className={cn('table-placeholder', className)}>
      <CustomTableCell>{children}</CustomTableCell>
    </CustomTableRow>
  );
};

CustomTablePlaceholder.propTypes = propTypes;

export default CustomTablePlaceholder;
